import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.scss';

const Card = ({ header, actions, children }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>
        {header}
        {actions && <div className={styles.titleActions}>{actions}</div>}
      </div>
      <div className={styles.cardContent}>{children}</div>
    </div>
  );
};

Card.propTypes = {
  header: PropTypes.string,
  children: PropTypes.node,
  actions: PropTypes.object
};

export default Card;
